/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const download = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.344 8.281 8 10.937m0 0 2.656-2.656M8 10.937V2.5M3 14h10"
    />
  </svg>
)
export default download
